import React, { useState } from 'react';
import bannerImage from '../assets/images/blog1.jpg'; // Blog banner image
import defaultIcon from '../assets/images/file-icon.png'; // Default icon for files without a preview

const Blog = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [previewInput, setPreviewInput] = useState(null);
  const [fileInput, setFileInput] = useState(null);
  const [titleInput, setTitleInput] = useState('');
  const [descriptionInput, setDescriptionInput] = useState('');

  const handleFileUpload = () => {
    if (!fileInput) {
      alert('Please upload an original file.');
      return;
    }

    const newFile = {
      preview: previewInput ? URL.createObjectURL(previewInput) : defaultIcon,
      file: fileInput,
      title: titleInput || 'Untitled Document',
      description: descriptionInput || 'No description provided.',
    };

    setUploadedFiles((prevFiles) => [...prevFiles, newFile]);
    resetInputs();
  };

  const resetInputs = () => {
    setPreviewInput(null);
    setFileInput(null);
    setTitleInput('');
    setDescriptionInput('');
  };

  const handleFileDownload = (file) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file.file);
    link.download = file.file.name;
    link.click();
  };

  return (
    <section style={{ padding: '40px', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      {/* Blog Banner */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <img
          src={bannerImage}
          alt="Blog Banner"
          style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
        />
      </div>

      <h2 style={{ fontSize: '36px', color: '#22225f', textAlign: 'center', marginBottom: '20px' }}>Our Blog</h2>

      {/* Upload Section */}
      <div style={{ maxWidth: '800px', margin: '0 auto', marginBottom: '40px' }}>
        <h3 style={{ fontSize: '24px', color: '#22225f', textAlign: 'center', marginBottom: '20px' }}>Upload Files</h3>

        {/* Input Fields */}
        <div>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px' }}>Upload Preview Image:</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setPreviewInput(e.target.files[0])}
            style={{
              display: 'block',
              marginBottom: '20px',
              padding: '10px',
              width: '100%',
              fontSize: '14px',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          />
        </div>

        <div>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px' }}>Upload Original File:</label>
          <input
            type="file"
            accept=".pdf,.ppt,.pptx"
            onChange={(e) => setFileInput(e.target.files[0])}
            style={{
              display: 'block',
              marginBottom: '20px',
              padding: '10px',
              width: '100%',
              fontSize: '14px',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          />
        </div>

        <div>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px' }}>Enter a Title:</label>
          <input
            type="text"
            value={titleInput}
            onChange={(e) => setTitleInput(e.target.value)}
            placeholder="Enter a title"
            style={{
              display: 'block',
              marginBottom: '20px',
              padding: '10px',
              width: '100%',
              fontSize: '14px',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          />
        </div>

        <div>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px' }}>Enter a Description:</label>
          <textarea
            value={descriptionInput}
            onChange={(e) => setDescriptionInput(e.target.value)}
            placeholder="Enter a description"
            style={{
              display: 'block',
              marginBottom: '20px',
              padding: '10px',
              width: '100%',
              fontSize: '14px',
              borderRadius: '5px',
              border: '1px solid #ccc',
            }}
          ></textarea>
        </div>

        <button
          onClick={handleFileUpload}
          style={{
            display: 'block',
            margin: '0 auto',
            padding: '10px 20px',
            backgroundColor: '#0073e6',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          Upload File
        </button>
      </div>

      {/* Uploaded Files Display */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
        }}
      >
        {uploadedFiles.map((file, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#fff',
              border: '1px solid #ddd',
              borderRadius: '10px',
              padding: '10px',
              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
              gap: '15px',
            }}
          >
            {/* Preview Image */}
            <img
              src={file.preview}
              alt={file.title}
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'cover',
                borderRadius: '10px',
                cursor: 'pointer',
              }}
              onClick={() => handleFileDownload(file)}
            />

            {/* File Details */}
            <div>
              <h4 style={{ fontSize: '18px', color: '#22225f', marginBottom: '5px' }}>{file.title}</h4>
              <p style={{ fontSize: '14px', color: '#555', marginBottom: '10px' }}>{file.description}</p>
              <button
                onClick={() => handleFileDownload(file)}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#0073e6',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '14px',
                  cursor: 'pointer',
                }}
              >
                Download
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Floating WhatsApp Chat Button */}
      <a
        href="https://wa.me/917569523497?text=Hello!%20I%20have%20a%20question%20regarding%20your%20blog%20content."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25d366',
          borderRadius: '50%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          style={{ width: '40px', height: '40px' }}
        />
      </a>
    </section>
  );
};

export default Blog;
